import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import BackToTop from "@/components/feature/BackToTop";
import HeroSection from "@/pages/home/components/HeroSection";
import TickerStrip from "@/pages/home/components/TickerStrip";
import CategorySection from "@/pages/home/components/CategorySection";
import FeaturedSection from "@/pages/home/components/FeaturedSection";
import LatestSection from "@/pages/home/components/LatestSection";
import KeywordSection from "@/pages/home/components/KeywordSection";
import FaqPreview from "@/pages/home/components/FaqPreview";
import AboutTeaser from "@/pages/home/components/AboutTeaser";
import useSeo from "@/hooks/useSeo";
import { faqGroups } from "@/mocks/faq";
import { siteInfo } from "@/mocks/site";

export default function Home() {
  const origin = window.location.origin;
  const homeFaq = [...faqGroups[0].items.slice(0, 3), faqGroups[1].items[0]];

  useSeo({
    title: "15黑料网 - 黑料关键词搜索与热门黑料词索引工具",
    description:
      "15黑料网提供黑料关键词检索服务，支持按黑料标签、分类查找与关键词搜索快速定位目标内容。热门黑料词索引持续更新，输入人物或事件名称即可找到对应黑料汇总。",
    keywords: "15黑料网,关键词搜索,黑料标签,分类查找,黑料索引,热门黑料词",
    path: "/",
    jsonLd: [
      {
        "@context": "https://schema.org",
        "@type": "WebSite",
        name: siteInfo.name,
        url: origin,
        description: siteInfo.intro,
        inLanguage: "zh-CN",
        potentialAction: {
          "@type": "SearchAction",
          target: `${origin}/keywords?q={search_term_string}`,
          "query-input": "required name=search_term_string",
        },
      },
      {
        "@context": "https://schema.org",
        "@type": "Organization",
        name: siteInfo.name,
        url: origin,
        email: siteInfo.email,
        foundingDate: siteInfo.since,
        description: "以关键词为核心的内容索引工具，整理公开可见的话题线索与时间线。",
      },
      {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: homeFaq.map((item) => ({
          "@type": "Question",
          name: item.q,
          acceptedAnswer: { "@type": "Answer", text: item.a },
        })),
      },
    ],
  });

  return (
    <div className="flex min-h-screen flex-col bg-background-50">
      <SiteHeader />
      <main className="flex-1">
        <HeroSection />
        <TickerStrip />
        <CategorySection />
        <FeaturedSection />
        <LatestSection />
        <KeywordSection />
        <FaqPreview />
        <AboutTeaser />
      </main>
      <SiteFooter />
      <BackToTop />
    </div>
  );
}